// extracted by mini-css-extract-plugin
module.exports = {"menu":"Admin_menu_3UlQ9","tab":"Admin_tab_2nGwR","selected":"Admin_selected_SRJmf","content":"Admin_content_2Q_jY"};